import { WorkWithUsSection } from '@components/sections/WorkWithUsSection'
import SoftwareDev from '@public/images/feedback-software-development.svg'

import { config } from './config'
import { Wrapper } from './styles'

export default function FeedbackSection() {
  return (
    <Wrapper>
      <WorkWithUsSection {...config}>
        <SoftwareDev />
      </WorkWithUsSection>
    </Wrapper>
  )
}
